/**
 * Pure helpers for terminal message-list transitions after a stream ends.
 *
 *  - `markMessagesAsError` — replaces the in-flight bot bubble with an
 *    error marker on the originating user message.
 *  - `removeBotMessage`    — drops a bot bubble entirely (used on user
 *    cancellation).
 */
import { Message } from '../components/features/chat/types';

/**
 * Remove the in-flight bot bubble and tag the originating user message
 * with `hasError` + `errorDetails` so the retry banner can render.
 */
export function markMessagesAsError(
  messages: Message[],
  userMessageId: string,
  botMessageId: string,
  error: string,
  errorDetails?: any,
): Message[] {
  const filtered = messages.filter(msg => msg.id !== botMessageId);
  return filtered.map(msg => {
    if (msg.id === userMessageId) {
      return {
        ...msg,
        hasError: true,
        errorDetails: errorDetails || { message: error, stack: new Error().stack },
      };
    }
    return msg;
  });
}

/** Drop a single bot bubble (used when the user aborts mid-stream). */
export function removeBotMessage(messages: Message[], botMessageId: string): Message[] {
  return messages.filter(msg => msg.id !== botMessageId);
}
